import { useContext, useMemo } from "react";
import FeatureFlagContext from "./FeatureFlagProvider";
import { FeatureFlags } from "us.common/constants";

/**
 * Retrieves the status of a feature flag.
 * @param flagName - The name of the feature flag to check.
 * @returns An object containing:
 *  - isEnabled: A boolean indicating if the feature flag is enabled.
 *  - isLoading: A boolean indicating if the feature flags are still loading.
 */
const useFeatureFlag = (
  flagName: FeatureFlags
): { isEnabled: boolean; isLoading: boolean } => {
  const { flags, isLoading } = useContext(FeatureFlagContext);

  const isEnabled = useMemo(() => {
    try {
      const flag = flags?.find(
        (feature: any) => feature?.featureName == flagName
      );
      return flag ? flag.isEnabled : false;
    } catch {
      return false;
    }
  }, [flagName, flags]);

  return { isEnabled, isLoading };
};

export default useFeatureFlag;
